import { BUILD_TYPE_NAMESPACE_MAP, LANGUAGE_OVERWRITE_MAP } from "./constants";

export const getLanguageOverwrite = (lng: string) => {
  return LANGUAGE_OVERWRITE_MAP[lng] || lng;
};

export const getNamespaceForBuildType = (buildType: string) => {
  return BUILD_TYPE_NAMESPACE_MAP[buildType] || BUILD_TYPE_NAMESPACE_MAP.default;
};
